import { render, staticRenderFns } from "./AppAccountInvite.vue?vue&type=template&id=0beb0418&lang=pug&"
import script from "./AppAccountInvite.vue?vue&type=script&lang=ts&"
export * from "./AppAccountInvite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports